import gettext from '@sdk/lang/gettext';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';
import Text14 from '@sdk/components/ui/typography/Text14';
import Row from '@sdk/components/ui/spacing/Row';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { Button, Container } from './ConfirmationTooltip.styles';

type Props = {
  content: string;
  onClick: () => void;
};

export const ConfirmationTooltip = ({ content, onClick }: Props) => (
  <Container>
    <Row pTop={5} pBottom={5} pLeft={10} pRight={10}>
      <Text14 themeColor={ThemeColorType.white}>{content}</Text14>
    </Row>
    <Button buttonType={ButtonType.tooltip} onClick={onClick}>
      {gettext('Got it')}
    </Button>
  </Container>
);
